import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BsDatepickerDirective} from 'ngx-bootstrap/datepicker';
import {FormsModule} from '@angular/forms';
import {InputSelectComponent} from './components/inputs/input-select/input-select.component';
import {InputTextComponent} from './components/inputs/input-text/input-text.component';
import {InputErrorWrapperComponent} from './components/input-error-wrapper/input-error-wrapper.component';
import {
    InputFlatSelectListComponent
} from './components/inputs/input-flat-select-list/input-flat-select-list.component';
import {InputFlatSelectComponent} from './components/inputs/input-flat-select/input-flat-select.component';
import {InputCheckboxComponent} from './components/inputs/input-checkbox/input-checkbox.component';
import {DateRangeDirective} from './validators/date-range.directive';
import {ValidateDirective} from './validators/validate.directive';
import {InvalidValueListDirective} from './validators/invalid-value-list.directive';
import {SameAsDirective} from './validators/same-as.directive';
import {NotSameValueAsDirective} from './validators/not-same-value-as.directive';
import {MaxNumberDirective} from './validators/max-number.directive';
import {ClickOutsideDirective} from './directives/click-outside.directive';
import {OnScrollDirective} from './directives/on-scroll.directive';
import {BaseOutsideClickScrollEventListenerDirective} from './directives/base-outside-click-scroll-event-listener.directive';


@NgModule({
    declarations: [
        BaseOutsideClickScrollEventListenerDirective,
        ClickOutsideDirective,
        DateRangeDirective,
        InputCheckboxComponent,
        InputErrorWrapperComponent,
        InputFlatSelectComponent,
        InputFlatSelectListComponent,
        InputSelectComponent,
        InputTextComponent,

        InvalidValueListDirective,
        MaxNumberDirective,
        NotSameValueAsDirective,
        OnScrollDirective,
        SameAsDirective,
        ValidateDirective
    ],
    imports: [
        BsDatepickerDirective,
        CommonModule,
        FormsModule
    ],
    exports: [
        BaseOutsideClickScrollEventListenerDirective,
        ClickOutsideDirective,
        DateRangeDirective,
        InputCheckboxComponent,
        InputErrorWrapperComponent,
        InputFlatSelectComponent,
        InputFlatSelectListComponent,
        InputSelectComponent,
        InputTextComponent,

        InvalidValueListDirective,
        MaxNumberDirective,
        NotSameValueAsDirective,
        OnScrollDirective,
        SameAsDirective,
        ValidateDirective
    ],
})
export class SharedFormsModule {
}
